import {formatAddressObjtoString} from '@/utils';
import {getPrescriptionCoupon} from '@/utils/medicine';
import {MedicineService} from '@/services/medicine';

import MedicineOrderDetailsDefault from '@/views/common/medicine-order-details/medicine-order-details-default';
import MedicineOrderDetailsProgramWeighNow from '@/views/common/medicine-order-details/medicine-order-details-program-weighnow';
import MedicineOrderDetailsProgramFreeStyleLibre from '@/views/common/medicine-order-details/medicine-order-details-program-freestylelibre';
import MedicineOrderDetailsWatsonsPickup
  from '@/views/common/medicine-order-details/medicine-order-details-watsons-pickup';
import MedicineOrderDetailsWatsonsDelivery
  from '@/views/common/medicine-order-details/medicine-order-details-watsons-delivery';
import MedicineOrderDetailsHipres from '@/views/common/medicine-order-details/medicine-order-details-hipres';
import Routes from '@/router/routes';
import ToastMixin from '@/mixins/toast-mixin';

import {
  COUPON_FULFILLMENT_MODE,
  DEFAULT_PHARMACIES,
} from '@/reference/medicine';

import {
  BRANCH_PICKUP_PAGES,
  DELIVERY_PAGES,
} from '@/reference/pharmacy-order-steps';

import {
  isSaxendaProgramId,
  isFSLEProgramId,
} from '@/reference/coupon';

import {mapGetters} from 'vuex';
import {
  GETTER_FILES_WITH_PROGRAM,
} from '@/store/types';


export default {
  name: 'root-medicine-order-details-mixin',
  mixins: [
    ToastMixin,
  ],
  props: {
    token: {type: String}
  },
  data() {
    return {
      loading: false,
      serviceOrder: null,
      currentStep: 0,
      watsonBranches: [],
    };
  },
  computed: {
    ...mapGetters({
      filesProgram: GETTER_FILES_WITH_PROGRAM,
    }),
    computedTitle() {
      if (!this.serviceOrder) {
        return 'txt070';
      }

      return this.serviceOrder.partnercode === DEFAULT_PHARMACIES.hipres ||
      this.serviceOrder.partnercode === DEFAULT_PHARMACIES.hipres_test ? 'txt258' : 'txt070';
    },
    displayedComponent() {
      if (!this.serviceOrder) return null;

      if (this.serviceOrder.partnercode === DEFAULT_PHARMACIES.watsons) {
        return this.serviceOrder.fulfillmentmode === COUPON_FULFILLMENT_MODE.DELIVERY
          ? MedicineOrderDetailsWatsonsDelivery
          : MedicineOrderDetailsWatsonsPickup;
      }

      if (this.serviceOrder.partnercode === DEFAULT_PHARMACIES.hipres || this.serviceOrder.partnercode === DEFAULT_PHARMACIES.hipres_test) {
        return MedicineOrderDetailsHipres;
      }

      if (this.serviceOrder.coupons) {
        const {programid} = getPrescriptionCoupon(this.serviceOrder);

        if (isSaxendaProgramId(programid)) return MedicineOrderDetailsProgramWeighNow;
      }

      const matchedFile = this.filesProgram.find(file => file.uploadid === this.serviceOrder.prescriptions[0].uploadid);
      if (matchedFile) {
        const matchedFileCoupon = getPrescriptionCoupon(matchedFile);

        if (matchedFileCoupon && isFSLEProgramId(matchedFileCoupon.programid)) return MedicineOrderDetailsProgramFreeStyleLibre;
      }

      return MedicineOrderDetailsDefault;
    },
    displaySteps() {
      if (!this.serviceOrder) return false;

      return this.serviceOrder.partnercode === DEFAULT_PHARMACIES.watsons;
    },
    isTwoCol() {
      if (!this.serviceOrder) return false;

      return this.serviceOrder.partnercode === DEFAULT_PHARMACIES.watsons;
    },
    steps() {
      if (!this.serviceOrder) return [];

      return this.serviceOrder.fulfillmentmode === COUPON_FULFILLMENT_MODE.DELIVERY
        ? DELIVERY_PAGES
        : BRANCH_PICKUP_PAGES;
    },
  },
  watch: {
    steps(steps) {
      this.currentStep = steps.length;
    },
  },
  mounted() {
    this.fetchOrder();
  },
  methods: {
    goBack() {
      // 2 because of the initial browser empty tab then the pxportal tab
      if (window.history.length <= 2 || this.$route.name === Routes.MEDICINE_ORDER_LAB_REQUESTS) {
        this.$router.push({name: Routes.SERVICES_ONGOING_ROUTE});
      } else {
        this.$goBack();
      }
    },
    async fetchOrder() {
      this.loading = true;

      try {
        const {data} = await MedicineService.getOrder(this.$route.params[Routes.MEDICINE_ORDER_ID_PARAM]);
        const {data: branches} = await MedicineService.getWatsonsBranch();
        this.serviceOrder = {
          ...data,
          addressString: formatAddressObjtoString(data.address),
        };
        this.watsonBranches = branches;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        this.$router.name({name: Routes.ERROR_ROUTE});
        this.showToast({
          text: 'Order doesn\'t exists.',
          theme: 'danger',
        });
      }
    },
  },
}